import { browser } from "$app/environment";
import { mergeObjects } from "$utils/ts-helpers";
export const KEY = "store";

export function loadLocalStorageState(key: string) {
  try {
    const serializedState = browser && window.localStorage.getItem(key);
    if (!serializedState) return undefined;
    return JSON.parse(serializedState);
  } catch (e) {
    throw new Error(`Failed to load local state: ${(e as Error).message}`);
  }
}

export async function saveStateToLocalStorage(key: string, state: any) {
  try {
    const currentState = loadLocalStorageState(key) || {};
    const newState = mergeObjects(currentState, state);
    const serializedState = JSON.stringify(newState);
    if (browser) {
      window.localStorage.setItem(key, serializedState);
    }
  } catch (e: unknown) {
    throw new Error(`Failed to save local state: ${(e as Error).message}`);
  }
}
